import React, { useEffect, useState } from "react";
import axios from "axios";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import {
  Container,
  Typography,
  Box,
  Button,
  Stack,
  Tooltip
} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import DescriptionIcon from "@mui/icons-material/Description";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import imgPoster1 from "../../assets/imgs/2แผ่นเล่นเกม_Page_11-727x1024.jpg";
import imgPoster2 from "../../assets/imgs/1วิธีเล่นเกมบิงโกกัญชา.jpg";

const BingoPage1 = () => {
  const openPdf = filename => {
    window.open("/api/file5_1/" + encodeURIComponent(filename), "_blank");
  };

  // downloads
  const handleDownloadInstructions = () =>
    openPdf("1วิธีเล่นเกมบิงโกกัญชา-1.pdf");

  const handleDownloadSheets = () => openPdf("2แผ่นเล่นเกม-1.pdf");

  const handleDownloadQuestions = () => openPdf("3บัตรคำถาม.pdf");

  // image previews
  const handleOpenImage1 = () => openPdf("2แผ่นเล่นเกม-1.pdf");

  const handleOpenImage2 = () => openPdf("1วิธีเล่นเกมบิงโกกัญชา-1.pdf");

  return (
    <React.Fragment>
      <Navbar />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh" // ทำให้สูงเท่าหน้าจอ
        }}
      >
        <Container sx={{ textAlign: "center", maxWidth: "md" }}>
          <Typography
            gutterBottom
            sx={{
              mt: 18,
              fontWeight: 700,
              fontFamily: "Poppins, sans-serif",
              textAlign: "center",
              background: "linear-gradient(90deg, #3F51B5, #00BCD4)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: { xs: "1.4rem", sm: "1.6rem", md: "1.8rem" },
              textShadow: "1px 1px 2px rgba(0,0,0,0.08)",
              letterSpacing: "0.8px",
              lineHeight: 1.4
            }}
          >
            เกมบิงโก “จะเกิดอะไรขึ้นเมื่อเด็ก-เยาวชนเสพกัญชา”
          </Typography>

          <Stack
            direction={{ xs: "column", sm: "column" }}
            spacing={2}
            sx={{ mt: 4, alignItems: "center" }}
          >
            <Tooltip title="คลิกดาวน์โหลด - วิธีเล่นเกมบิงโกกัญชา">
              <Button
                variant="contained"
                startIcon={<CloudDownloadIcon />}
                onClick={handleDownloadInstructions}
                sx={{
                  width: { xs: "90%", sm: 420 },
                  height: 64,
                  bgcolor: "#d32f2f",
                  color: "#fff",
                  fontWeight: 700,
                  textTransform: "none",
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                  boxShadow: "0 12px 30px rgba(211,47,47,0.18)",
                  "&:hover": { bgcolor: "#c62828" }
                }}
              >
                วิธีเล่นเกมบิงโกกัญชา (คลิกดาวน์โหลด)
              </Button>
            </Tooltip>

            <Tooltip title="คลิกดาวน์โหลด - แผ่นเล่นเกม 12 แผ่น">
              <Button
                variant="outlined"
                startIcon={<DescriptionIcon />}
                onClick={handleDownloadSheets}
                sx={{
                  width: { xs: "90%", sm: 420 },
                  height: 64,
                  color: "#1976d2",
                  borderColor: "rgba(25,118,210,0.3)",
                  fontWeight: 700,
                  textTransform: "none",
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                  boxShadow: "0 8px 24px rgba(25,118,210,0.08)",
                  "&:hover": { bgcolor: "rgba(25,118,210,0.04)" }
                }}
              >
                แผ่นเล่นเกม 12 แผ่น (คลิกดาวน์โหลด)
              </Button>
            </Tooltip>

            <Tooltip title="คลิกดาวน์โหลด - บัตรคำถาม 32 คำถาม">
              <Button
                variant="contained"
                color="secondary"
                startIcon={<HelpOutlineIcon />}
                onClick={handleDownloadQuestions}
                sx={{
                  width: { xs: "90%", sm: 420 },
                  height: 64,
                  bgcolor: "#6a1b9a",
                  color: "#fff",
                  fontWeight: 700,
                  textTransform: "none",
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                  boxShadow: "0 10px 26px rgba(106,27,154,0.14)",
                  "&:hover": { bgcolor: "#4a148c" }
                }}
              >
                บัตรคำถาม 32 คำถาม (คลิกดาวน์โหลด)
              </Button>
            </Tooltip>
          </Stack>

          <Box
            sx={{
              mt: 3,
              display: "flex",
              flexDirection: "column",
              gap: 2,
              alignItems: "center"
            }}
          >
            <Box
              component="img"
              src={imgPoster1}
              alt="โปสเตอร์บิงโก 1"
              onClick={handleOpenImage1}
              sx={{
                width: "100%",
                maxWidth: 574,
                cursor: "pointer",
                borderRadius: 1,
                boxShadow: "0 6px 18px rgba(0,0,0,0.08)"
              }}
            />

            <Box
              component="img"
              src={imgPoster2}
              alt="โปสเตอร์บิงโก 2"
              onClick={handleOpenImage2}
              sx={{
                width: "100%",
                maxWidth: 574,
                cursor: "pointer",
                borderRadius: 1,
                boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                mb: 6
              }}
            />
          </Box>
        </Container>
      </Box>

      <Footer />
    </React.Fragment>
  );
};

export default BingoPage1;
